export default class Locale_Comments { 
	ActivityDesctiption = {
		OwnComment: 'You',
		NotOwnComment: `[[authorname]] ([[authorrole]])`,
	}
	Delete: string = 'Delete';
	Comments: string = 'Comments';
	HitEnterToSave: string = "Hit enter to save..";
	Edit: string = "Edit"
}